<template>
  <div class="container-fluid-navbar">
    <div class="container">
      <div class="texture left">
        <img src="@/assets/texture.png" />
      </div>
      <div class="row">
        <div class="col-12">
					<img src="@/assets/logo_univision.png" alt="" width="165px"/>
        </div>
      </div>
      <div class="texture">
        <img src="@/assets/texture.png" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .container-fluid-navbar {
    position: sticky;
    top: 0;
    z-index: 9;

    .texture {
      position: absolute;
      right: 0;
      top: 0;

      &.left {
        right: 99vw;
      }

      img {
        height: 50px;
      }
    }
  }
</style>

<script>
	export default {
		name: 'NavBar',
		props: {
		msg: String
		}
	}
</script>